import React from 'react';

const Messages = ({type = 'info', children}) => (
	<div className={`message message--${type}`}>
		{children}
	</div>
);

export default Messages;


// WEBPACK FOOTER //
// ./src/components/Messages/index.js